import React, { useState } from "react";
import {
  BlurWrapperWithSpan,
  FloatLabelInput,
} from "../../Utils/CustomComponent";
import { Eye, EyeSlash } from "react-bootstrap-icons";

const UseFormLabelInput = ({
  title,
  type,
  field,
  register,
  watch,
  error,
  disable,
  disablePaste,
  eyeIcon = false,
  blur = false,
  control,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const fieldType = eyeIcon
    ? showPassword
      ? type || "text"
      : "password"
    : type || "text";

  return (
    <div style={eyeIcon ? { position: "relative" } : null}>
      {blur ? (
        <BlurWrapperWithSpan>
          <FloatLabelInput
            register={{ ...register(field) }}
            label={title}
            value={watch(field) || ""}
            // type={type || "text"}
            type={fieldType}
            error={error}
            disabled={disable}
            disablePaste={disablePaste}
            control={control}
            field={field}
          />
        </BlurWrapperWithSpan>
      ) : (
        <FloatLabelInput
          register={{ ...register(field) }}
          label={title}
          value={watch(field) || ""}
          // type={type || "text"}
          type={fieldType}
          error={error}
          disabled={disable}
          disablePaste={disablePaste}
          control={control}
          field={field}
        />
      )}
      {eyeIcon ? (
        <div
          style={{
            position: "absolute",
            top: "15px",
            right: "2rem",
            cursor: "pointer",
          }}
          onClick={() => setShowPassword((pass) => !pass)}
        >
          {showPassword ? <Eye size={20} /> : <EyeSlash size={20} />}
        </div>
      ) : null}
    </div>
  );
};

export default UseFormLabelInput;
